





















































































































































import Toast from '@common/helpers/toast';

import { Vue, Component, Prop } from 'vue-property-decorator';
import momentTz from 'moment-timezone';
import moment, { Moment } from 'moment';
import ApiHelper from 'api-helper';
import { URL_REGEX } from '@common/app.config';
import { Action, State } from 'vuex-class';
import { Patient } from '@/models/patient';
import lodashGet from 'lodash/get';
import InfiniteLoading from 'vue-infinite-loading';
import PageLoader from '@components/common/PageLoader.vue';
import MessageImage from '@components/v2/patient/message/MessageImage.vue';
import MessageTemplate from '@components/v2/patient/message/MessageTemplate.vue';
import MessageText from '@components/v2/patient/message/MessageText.vue';
import MessageLink from '@components/v2/patient/message/MessageLink.vue';
import MessageButton from '@components/v2/patient/message/MessageButton.vue';
import MessageLabel from '@components/v2/patient/message/MessageLabel.vue';
import MessageClinicPattern from '@components/v2/patient/message/MessageClinicPattern.vue';
import PopupConfirmDelete from '@components/v2/patient/message/PopupConfirmDelete.vue';
import { MESSAGE_BUTTON_TYPE, MESSAGE_TYPE } from '@/common/enums/message';
import MedicalRecordPopup from '@components/v2/patient/message/MedicalRecordPopup.vue';
import VideoComponent from '@components/v2/patient/message/VideoComponent.vue';
import { USER_TREATMENT_STATE } from '@/common/constants/auth';
import { UserTreatment } from '@/models/user-treatment';
import PlanListSuggestPopup from '@components/v2/patient/message/PlanListSuggestPopup.vue';
import { MessageEvent } from '@/events/message';
import BasicSelect from '@/components/common/BasicSelect.vue';

@Component({
  components: {
    InfiniteLoading,
    PageLoader,
    MessageImage,
    MessageTemplate,
    MessageText,
    MessageLink,
    MessageButton,
    MessageLabel,
    MessageClinicPattern,
    MedicalRecordPopup,
    VideoComponent,
    PopupConfirmDelete,
    PlanListSuggestPopup,
    BasicSelect,
  },
})
export default class Chat extends Vue {
  @State((state) => state.treatment_detail.data) activeTreatment: UserTreatment;
  @State((state: any) => state.video_call.isVideoCall) isVideoCall!: boolean;
  @Action('video_call/setVideoCall') setVideoCall!: (status: boolean) => void;

  get getVideoComponent() {
    return this.$refs.videoComponent as any;
  }

  get showBtnVideoCall() {
    const reservationDate = lodashGet(this.userReservation, 'reservation_date');
    const reservationCallTime = lodashGet(this.userReservation, 'ampm1');
    const doctorId = lodashGet(this.userReservation, 'doctor_id');

    const reservationMoment = momentTz.tz(
      reservationDate,
      'YYYY-MM-DD HH:mm:ss',
      'Asia/Tokyo',
    );
    const now = momentTz().tz('Asia/Tokyo');

    return (
      Number(this.currentUser.id) === Number(doctorId) &&
      now.isBetween(
        reservationMoment.clone().subtract(10, 'minutes'),
        reservationMoment.clone().add(reservationCallTime, 'minutes'),
      )
    );
  }
  get showBtnChatReminder() {
    return (
      this.currentUser.isDoctorRole &&
      this.userReservation.user_treatment &&
      [
        USER_TREATMENT_STATE.CHAT_INTERVIEW_SCHEDULED,
        USER_TREATMENT_STATE.CHAT_CONSULTATION_IN_PROGRESS,
      ].includes(this.userReservation.user_treatment.state)
    );
  }
  get showBtnPlanListSuggest() {
    const treatment = this.userReservation?.user_treatment;
    const feedbackState = treatment?.last_doctor_feedback?.state;
    const currentDoctorId = Number(this.currentUser.id);
    const treatmentDoctorId = Number(
      treatment?.last_doctor_feedback?.doctor_id,
    );
    const isDoctorOwner = currentDoctorId === treatmentDoctorId;

    return (
      isDoctorOwner &&
      treatment?.state === USER_TREATMENT_STATE.CONFIRMING_PRESCRIPTION &&
      (!feedbackState || feedbackState === 'pending')
    );
  }

  get isTreatmentDisabled(): boolean {
    const disabledStates = [
      USER_TREATMENT_STATE.CANCELED,
      USER_TREATMENT_STATE.DOCTOR_CANCEL_PRESCRIPTION,
    ];

    return disabledStates.includes(this.activeTreatment?.state);
  }

  get treatmentId(): number | null {
    return this.activeTreatment?.id ?? null;
  }

  get lastFeedback() {
    const lastFeedback = lodashGet(this.userReservation, 'user_treatment.last_doctor_feedback');
    return lastFeedback ? lastFeedback : null;
  }

  @State((state) => state.patient_detail.data) currentPatient!: Patient;
  @State((state) => state.auth.currentUser) currentUser!: any;
  private messages: any = [];
  private isSending: boolean = false;
  private filterParam = {
    per_page: 20,
    page: 1,
    current_page: 1,
    totalPage: 1,
    order: '-id',
    with: 'senderable,suggestPlan,suggestPlan.treatment',
    user_treatment_id: null as number | null,
  };
  private currentChannel: any = null;
  private isLoading: boolean = false;
  private medicalRecord: any = {
    hasData: false,
    feedbackList: [],
    answer: [],
    question: [],
    feedbackForm: {
      id: null,
      created_at_jp: null,
      content: '',
      plans: [],
      type: null,
    },
  };
  private userReservation: any = {};
  private showActionMessageId: number | null = null;
  private messageId: number | null = null;
  private messageChange: any = null;
  private handlerOptions = [
    { name: 'CS対応中', value: 'cs' },
    { name: 'ドクター対応中', value: 'doctor' },
  ];

  /**************** Setter ****************/
  setVideo() {
    if (this.isTreatmentDisabled) {
      return;
    }
    this.setVideoCall(true);
    this.$emit('show-video', this.currentChannel, this.currentPatient);
  }
  onChangeSending(isSending = true) {
    this.isSending = isSending;
  }
  setChannel(channel) {
    this.currentChannel = channel;
  }
  setLoading(isLoading = true) {
    this.isLoading = isLoading;
  }
  setFilterParam(filterParam) {
    this.filterParam = { ...this.filterParam, ...filterParam };
  }
  showPlanListSuggestModal() {
    this.$modal.show('plan-list-suggest-popup');
  }
  onFeedbackCompleted() {
    const userTreatment = this.userReservation?.user_treatment;
    if (userTreatment?.last_doctor_feedback) {
      this.$set(userTreatment.last_doctor_feedback, 'state', 'completed');
    } else if (userTreatment) {
      this.$set(userTreatment, 'last_doctor_feedback', { state: 'completed' });
    }
  }

  /**************** life cycle ****************/
  async created() {
    if (!this.currentPatient || !this.currentPatient.id) {
      Toast.error('患者情報がありません。');
      return;
    }

    const userTreatmentId = this.$route.query.user_treatment_id;
    if (this.activeTreatment?.id) {
      this.filterParam.user_treatment_id = this.activeTreatment.id;
    } else if (userTreatmentId) {
      this.filterParam.user_treatment_id = Number(userTreatmentId);
    }
    // channel data is required for this page.
    await this.loadChannel();
    await this.getAnswerData();

    this.$on(`OnMessageCreated_${this.currentChannel.id}`, this.onReceiveMessage);
    this.$on(`MessageUpdated_${this.currentChannel.id}`, this.onUpdateMessage);
    this.$on(`MessageDeleted_${this.currentChannel.id}`, this.onMessageDeleted);

    this.scrollToBottom(200);
  }

  beforeDestroy() {
    if (this.currentChannel?.id) {
      this.$off(`OnMessageCreated_${this.currentChannel.id}`);
      this.$off(`MessageUpdated_${this.currentChannel.id}`);
      this.$off(`MessageDeleted_${this.currentChannel.id}`);
    }

    this.$modal.hide('message-input-modal');
  }

  /**************** methods ****************/

  async reminderChat() {
    if (this.isTreatmentDisabled) {
      return;
    }
    try {
      const params = {
        user_treatment_id: this.activeTreatment.id,
      };

      await ApiHelper.getApi('PatientV2Api').reminderChat(this.currentPatient.id, params);
      Toast.success('リマインドメッセージを送信しました。');
    } catch (error) {
      if (error.response) {
        Toast.error(error.response.data.message);
        return;
      }
      Toast.error(error.message);
    }
  }

  savedFeedback(feedback) {
    this.activeTreatment.state = feedback.user_treatment.state;
    this.activeTreatment.feedback_type = feedback.user_treatment.feedback_type;
    this.$store.commit('user_treatment_list/setUserTreatmentState', feedback.user_treatment);
    this.getListFeedback();
    this.getAnswerData();
  }

  async getListFeedback() {
    this.isLoading = true;
    const self = this;
    const payload = { user_treatment_id: this.activeTreatment.id, with: 'userTreatment.menu,plans,doctor' };
    await ApiHelper.getApi('PatientV2Api').getKarteList(this.currentPatient.id, payload)
      .then(function(res, error) {
        self.medicalRecord.feedbackList = res.data;
      })
      .catch((error: any) => {
        Toast.error(error.response.data.message);
      });
  }

  async getAnswerData() {
    if (this.activeTreatment.menu) {
      this.$store.commit('treatment_detail/setLoadingChild', true);
      await ApiHelper.getApi('PatientV2Api')
        .getReservation(this.currentPatient.id, {
          user_treatment_id: this.activeTreatment.id,
          with: 'answers,userTreatment.menu,userTreatment.lastDoctorFeedback',
        })
        .then((res: any) => {
          this.userReservation = res.data;
          this.medicalRecord.answer = res.data.answers;
        })
        .catch((err: any) => {
          console.log(err);
        })
        .finally(() => {
          this.$store.commit('treatment_detail/setLoadingChild', false);
        });
    }
  }

  get userTreatment() {
    return this.userReservation?.user_treatment || {};
  }

  get filteredHandlerOptions() {
    const current = this.userTreatment.handler_type;
    return this.handlerOptions.filter((opt) => opt.value !== current);
  }

  get handlerType() {
    return String(this.userTreatment.handler_type || 'doctor').toLowerCase();
  }

  get selectedHandlerOption() {
    return this.handlerOptions.find(
      (o) => o.value === this.handlerType,
    );
  }

  async onSelectHandler(value) {
    try {
      const id = this.userTreatment.id;

      await ApiHelper.getApi('UserTreatmentApi').changeHandler(id, value);

      this.$set(this.userTreatment, 'handler_type', value);
      this.$store.commit(
        'user_treatment_list/setUserTreatmentHandlerType',
        { id, handler_type: value },
      );

      Toast.success('担当者を更新しました');
    } catch (e) {
      Toast.error('更新に失敗しました');
    }
  }

  getTimeSection(time: Moment) {
    if (!time) {
      return;
    }

    if (time.isSame(moment(), 'date')) {
      return '今日';
    }

    return time.format('YYYY年MM月DD日');
  }

  async infiniteHandler($state) {
    const response = await ApiHelper.getApi('MessageApi').getMessages(this.currentChannel.id, this.filterParam);
    const { data, last_page, current_page } = response;
    let newMessageList: any = [];
    // stop load more if data is empty.
    if (data.length === 0) { return $state.complete(); }

    data.forEach((newMessage) => {
      // not found in oldMessageList.
      if (!this.messages.some((oldMessage) => newMessage.id === oldMessage.id)) {
        newMessageList.push(newMessage);
      }
    });

    let prevMessage = this.messages.at(-1) || {} ;
    newMessageList = newMessageList.reverse().map((message) => {
      message.timeSection = this.calculateSectionTime(prevMessage.created_at, message.created_at);
      prevMessage = message;

      return message;
    });
    this.messages.unshift(...newMessageList);

    this.setFilterParam({ page: current_page + 1, current_page });
    // when page > last page -> stop load more.
    this.filterParam.page <= last_page ? $state.loaded() : $state.complete();

    // reset unread message when load messages and check message unread is > 0.
    this.readAllMessages();
  }

  calculateSectionTime = (prevCreatedAt: string, currentCreatedAt: string) => {
    if (!prevCreatedAt && !!currentCreatedAt) {
      return moment(currentCreatedAt).isBefore(moment(), 'date') ? moment(currentCreatedAt) : '';
    }

    if (moment(prevCreatedAt).isBefore(moment(currentCreatedAt), 'date')) {
      return moment(currentCreatedAt);
    }

    return null;
  }

  async onReceiveMessage(data) {
    if (data.channel_id != this.currentChannel.id) {
      return;
    }

    // check reservation_id
    if (this.activeTreatment.reservations && data.reservation_id) {
      const isRelatedToTreatment = this.activeTreatment.reservations.some(
        (reservation) => reservation.id === data.reservation_id,
      );
      if (!isRelatedToTreatment) {
        return;
      }
    }

    // reset unread message.
    await this.readAllMessages();

    // push new message to state if this message is not exists state.
    if (!this.messages.find((message) => message.id === data.id)) {
      this.messages.push(data);
    }

    const userTreatment = this.userReservation?.user_treatment;
    if (
      userTreatment &&
      userTreatment.state === USER_TREATMENT_STATE.CHAT_INTERVIEW_SCHEDULED
    ) {
      this.$set(
        userTreatment,
        'state',
        USER_TREATMENT_STATE.CHAT_CONSULTATION_IN_PROGRESS,
      );
      this.$store.commit(
        'user_treatment_list/setUserTreatmentState',
        userTreatment,
      );
    }

    this.scrollToBottom(200);
  }

  scrollToBottom(duration: number = 0) {
    this.$nextTick(() => {
      const container = document.querySelector('.messages-history')!;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    });
  }

  isMessageText(item): boolean {
    // return [MESSAGE_TYPE.TEXT, MESSAGE_TYPE.PAYING, MESSAGE_TYPE.FOR_DOCTOR].includes(item.type_message)
    return MESSAGE_TYPE.TEXT === item.type_message && !this.isMessageUrl(item);
  }

  isMessageTemplate(item): boolean {
    return MESSAGE_TYPE.TEXT === item.type_message && this.isMessageUrl(item);
  }

  isMessageImage(item): boolean {
    return MESSAGE_TYPE.IMAGE === item.type_message;
  }

  isMessageLink(item): boolean {
    return MESSAGE_TYPE.LINK === item.type_message;
  }

  isMessageButton(item): boolean {
    return MESSAGE_TYPE.BUTTON === item.type_message;
  }

  isMessageLabel(item): boolean {
    return MESSAGE_TYPE.LABEL === item.type_message;
  }

  isMessageDoctorFeedbackPending(item): boolean {
    try {
      const content = JSON.parse(item.message_content);
      return (
        MESSAGE_TYPE.DOCTOR_FEEDBACK_PENDING === item.type_message &&
        content &&
        content.action === MESSAGE_BUTTON_TYPE.FEEDBACK_PENDING
      );
    } catch (error) {
      return false;
    }
  }

  isMessageClinicPattern(item): boolean {
    return MESSAGE_TYPE.CLINIC_PATTERN === item.type_message;
  }

  isMessageUrl(item) {
    const pattern = new RegExp(URL_REGEX);
    return !!pattern.test(item.message_content);
  }

  handleEditMessage(message) {
    MessageEvent.$emit('edit-message', { message });
    this.handleMessageInputModal();
  }

  handleDeleteMessage(message) {
    this.messageId = message.id;
    this.$modal.show('popup-confirm-delete');
  }

  onUpdateMessage(message) {
    if (message.channel_id !== this.currentChannel.id) {
      return;
    }

    const index = this.messages.findIndex((item) => item.id === message.id);
    if (index !== -1) {
      this.$set(this.messages, index, {
        ...this.messages[index],
        image_url: message.image_url,
        message_content: message.message_content,
        attachment_image_url: message.attachment_image_url,
        type_message: message.type_message,
      });
    }

    this.messageChange = null;
  }

  onMessageDeleted(message) {
    if (message.channel_id !== this.currentChannel.id) {
      return;
    }

    const messageIndex = this.messages.findIndex(
      (item) => item.id === message.message_id,
    );
    if (messageIndex > -1) {
      this.messages.splice(messageIndex, 1);
    }

    MessageEvent.$emit('reset-edit');
    this.messageId = null;
  }

  handleMessageInputModal() {
    if (this.isTreatmentDisabled) {
      return;
    }
    this.$emit(
      'show-message-input',
      this.currentChannel,
      this.messageChange,
    );
  }

  // call api reset unread message when focus input.
  async readAllMessages() {
    if (!this.currentChannel?.id) {
      return;
    }

    const params: any = {};
    if (this.activeTreatment?.id) {
      params.user_treatment_id = this.activeTreatment.id;
    }
    try {
      await ApiHelper
        .getApi('MessageApi')
        .readAllMessages(this.currentChannel.id, params);
      this.activeTreatment?.reservations?.forEach((r) => {
        this.$store.commit('user_treatment_list/syncUnreadCount', {
          reservationId: r.id,
          unreadMessageCount: 0,
        });
      });
    } catch (error) {
      Toast.error('未読メッセージのリセットに失敗しました。');
    }
  }

  async handleCompleteFeedback() {
    if (this.isTreatmentDisabled) {
      return;
    }
    if (!this.treatmentId) {
      return;
    }

    try {
      await ApiHelper.getApi('DoctorFeedbackApi').completeFeedback(
        this.treatmentId,
      );

      await this.onFeedbackCompleted();
      Toast.success('処方を確定しました。');
    } catch (error) {
      Toast.error(
        (error as any).response?.data?.message || '処方の確定に失敗しました。',
      );

      await this.syncTreatmentState();
    }
  }

  private async syncTreatmentState() {
    const treatmentId = this.treatmentId;
    const active = this.activeTreatment;

    if (!treatmentId || !active || active.id !== treatmentId) {
      return;
    }

    try {
      const response = await ApiHelper.getApi('UserTreatmentV2Api').index({
        user_id: this.currentPatient.id,
        id: treatmentId,
      });

      const updatedTreatment = response.data?.[0];
      if (!updatedTreatment || updatedTreatment.id !== treatmentId) {
        return;
      }

      active.state = updatedTreatment.state;
      active.feedback_type = updatedTreatment.feedback_type;
      this.$store.commit(
        'user_treatment_list/setUserTreatmentState',
        updatedTreatment,
      );
    } catch {
      // Intentionally ignored: user already saw Toast for the primary error.
    }
  }

  private async loadChannel() {
    this.$store.commit('treatment_detail/setLoadingChild', true);
    const channel = await ApiHelper.getApi('ChannelV2Api').show(this.currentPatient.id);
    this.setChannel(channel);
    this.$store.commit('treatment_detail/setLoadingChild', false);

    this.$nextTick(() => {
      this.$emit('show-message-input', this.currentChannel, this.messageChange);
    });
  }

  private showModal(modalName) {
    if (this.isTreatmentDisabled) {
      return;
    }
    // this.getPatientInfo();
    this.getListFeedback();
    this.medicalRecord.feedbackForm = {
      id: null,
      created_at_jp: null,
      content: '',
      plans: [],
      type: null,
    };
    this.$modal.show('chat-channel-popup');
  }
}
